import "./AtButton.css";

export default function AtButton({text, handleClick, radius, icon, color="#E52A30", notification, disabled}){
    return (
        <div
            className={`attendanceButton${disabled ? " attendanceButtonDisabled" : ""}`}
            style={{
                borderRadius: radius,
                backgroundColor: color,
                padding: icon ? undefined : "16px",
                position: "relative",
                opacity: disabled ? 0.6 : 1,
                pointerEvents: disabled ? "none" : "auto"
            }}
            onClick={disabled ? undefined : handleClick}
        >
            {icon ? <img src={icon} alt="button icon" className="attendanceButtonIcon"/> : null}
            {text}
            {notification > 0 && (
                <span className="notificationBubble">{notification}</span>
            )}
        </div>
    );
}
